<script lang="ts">
    import { createEventDispatcher } from 'svelte';
    import { getReactionsData } from './Utils';
    import keys from 'lodash/keys';
    import { clickOutside } from '$lib/utils/interractions.js';
    import { getContainer } from '$components/Context/ContainerContext';

    const dispatch = createEventDispatcher();
    const { lang } = getContainer();

    $: reactionsData = getReactionsData($lang);
    $: types = keys(reactionsData.images) as (keyof typeof reactionsData.images)[];
</script>

<div
    class="py-3 px-6 bg-white shadow-md border-gray-300 border rounded-full flex items-center gap-4"
    use:clickOutside
    on:outclick={() => dispatch('close')}
>
    {#each types as key (key)}
        <button
            on:click|preventDefault={() => dispatch('select', key)}
            class="btn-reset border-0 bg-transparent w-10 h-10 cursor-pointer hover:scale-[1.2] transition-transform duration-300 ease-in-out hover:scale"
        >
            <img
                class="w-full h-full"
                src={reactionsData.images[key]}
                alt={reactionsData.labels[key]}
            />
        </button>
    {/each}
</div>
